import { gql } from "@apollo/client";
export const GetTotalTransactions = gql `
  query GetTotalTransactions($input: GetTotalTransactionsInput!) {
    GetTotalTransactions(input: $input) {
      totalCount
      totalAmount
      transactions {
        _id
        type
        transactionDate
        amount
        sourceBankAccount {
          currency
        }
        destinationBankAccount {
          currency
        }
        company {
          _id
          name
        }
      }
    }
  }
`;
